import React, { type FC, useEffect, useState } from 'react';

import { Alert } from '@gravity-ui/uikit';
import i18n from '@yandex-int/i18n';
import { confirmEmail } from 'client/api';
import { IndexLayout } from 'client/blocks-redesign/Layout/Layout';
import { Link } from 'client/blocks-redesign/Link/Link';
import { PageLoader } from 'client/blocks-redesign/Loader/PageLoader';
import { wrapInText } from 'client/lib/i18n-utils';
import { routes } from 'client/lib/routes';
import { EmailConfirmationStage } from 'client/types';
import * as keyset from 'i18n/GeneralSettings';
import queryString from 'query-string';

import styles from './EmailPages.module.scss';

const t = i18n(keyset);

export const EmailConfirmation: FC = () => {
    const [stage, setStage] = useState<EmailConfirmationStage>('pending');
    const [skillId, setSkillId] = useState<string>('');

    useEffect(() => {
        const parsed = queryString.parse(location.search);

        if (!parsed.token) {
            return setStage('failure');
        }

        confirmEmail(parsed.token)
            .then((response) => {
                setStage(response.stage);
                setSkillId(response.skillId);
            })
            .catch((err) => {
                console.error(err);
                setStage('failure');
            });
    }, []);

    let content = <PageLoader />;

    if (stage === 'not-modified') {
        content = (
            <Alert
                message={
                    <div className={styles.emailPages__content}>
                        {wrapInText((s) => (
                            <Link to={routes.app.skillPage(true, 'settings', skillId)} theme="info">
                                {s}
                            </Link>
                        ))(t('email-confirmation-already-confirmed'))}
                    </div>
                }
                theme="info"
            />
        );
    }

    if (stage === 'success') {
        content = (
            <Alert
                message={
                    <div className={styles.emailPages__content}>
                        {wrapInText((s) => (
                            <Link to={routes.app.skillPage(true, 'settings', skillId)} theme="info">
                                {s}
                            </Link>
                        ))(t('email-confirmation-success'))}
                    </div>
                }
                theme="success"
            />
        );
    }

    if (stage === 'failure') {
        content = (
            <Alert
                message={<div className={styles.emailPages__content}>{t('email-confirmation-error')}</div>}
                theme="danger"
            />
        );
    }

    return (
        <IndexLayout>
            <div className={styles.emailPages__container}>{content}</div>;
        </IndexLayout>
    );
};
